module.exports = __webpack_public_path__ + "img/title.b0997227.png";